import React, {
  ReactElement,
  useState,
} from 'react';
import {Entity} from '../../../types/entities/Entity';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import {Paper} from "@mui/material";
import Box from "@mui/material/Box";
import {CloseRounded} from "@mui/icons-material";
import {styled, useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Grid from "@mui/material/Grid";
import {GroupComment} from "../../Comment/GroupComment";

type Props<T extends Entity> = {
  onClose: () => void;
  row: any;
  schema: any;
};

const Item = styled(Paper)(({theme}) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(1),
  boxShadow: 'none',
}));

export const ChatDialog = <T extends Entity>({
                                               onClose,
                                               row,
                                               schema
                                             }: Props<T>): ReactElement => {


  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<DialogProps['maxWidth']>('lg');

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={onClose}
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        <DialogTitle>Chat - {row?.name}</DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme: any) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseRounded/>
        </IconButton>

        <DialogContent dividers>

          <Box sx={{
            flexGrow: 1,
          }}>
            <Grid container spacing={0}>
              <Grid item xs={12} md={12} lg={12}>
                <Item>
                  <GroupComment
                    values={row}
                    schema={schema}
                    tableType={'groups'}
                    fullWidth={true}
                  />
                </Item>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );

};